import React, { useMemo } from "react";
import { Dropdown, Select } from "semantic-ui-react";
import {
  getCustomDays,
  getSevenDays,
  getThirtyDays,
  getToday,
} from "../../utils/getDay";
import { useTranslation } from "react-i18next";

const DateSelect = ({ setDatePicker, customDateList }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`betRecord.${key}`);

  const dateList = [
    {
      text: "Last 24 hours",
      value: 1,
      startDate: getToday(),
      endDate: getToday(),
    },
    {
      text: "Last 7 days",
      value: 7,
      startDate: getSevenDays(),
      endDate: getToday(),
    },

    {
      text: "Last 30 days",
      value: 30,
      startDate: getThirtyDays(),
      endDate: getToday(),
    },
    {
      text: "Last 60 days",
      value: 60,
      startDate: getCustomDays(60),
      endDate: getToday(),
    },
  ];

  const isCustomDateOrNot = useMemo(() => {
    return customDateList?.length > 0 ? customDateList : dateList;
  }, [customDateList]);

  return (
    <select
      onChange={(e) => {
        const result = isCustomDateOrNot.find((item) => {
          return item.value == e.target.value;
        });
        setDatePicker({
          str_date: result.startDate,
          end_date: result.endDate,
        });
      }}
      className="p-[5px] !bg-base-light-white dark:!bg-base-light-dark cursor-pointer font-semibold text-light-text outline-0 !rounded-xl w-full custom-select mb-[15px]"
    >
      {isCustomDateOrNot.map((option) => {
        return <option value={option.value}>{i18n(option.text)}</option>;
      })}
    </select>
  );
};

export default DateSelect;
